import { Box, Paper, Typography } from '@mui/material';

import DateText from '@/components/DateText';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';
import useUserDetails from '@/hooks/useUserDetails';

const AccountDetails = () => {
  const { isUserExpired, currentSubscription, expiredDate } = useUserDetails();

  const accessLevel = isUserExpired ? 'Expired' : currentSubscription;
  return (
    <Box
      component={Paper}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: 3,
        py: 2,
        width: '100%'
      }}
    >
      <Typography
        fontWeight={700}
        sx={theme => ({ pb: 1, borderBottom: `1px solid ${theme.palette.text.primary}` })}
        variant='subtitle1'
      >
        Account Details
      </Typography>
      <Box sx={{ display: 'flex', pt: 1 }}>
        <Typography
          sx={{ fontWeight: 600, lineHeight: 'normal', width: 150 }}
          variant='body2'
        >
          Access Level
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal', pb: 0.5 }}
          variant='body2'
        >
          {accessLevel}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Typography
          sx={{ fontWeight: 600, lineHeight: 'normal', width: 150 }}
          variant='body2'
        >
          Expiry Date
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal' }}
          variant='body2'
        >
          {expiredDate ? <DateText dateString={expiredDate.toJSON()} /> : 'Never'}
        </Typography>
      </Box>
      <UpgradeToPremiumButton
        sx={{ mt: 2 }}
        type={isUserExpired ? 'expired' : 'manage'}
      />
    </Box>
  );
};

export default AccountDetails;
